import {
  Classes,
  FormGroup,
  InputGroup,
} from "@blueprintjs/core";
import {
  MDBCol,
  MDBRow,
} from "mdbreact";
import { observer } from "mobx-react";
import * as React from "react";
import { IContador, newIContador } from "../../model";
import { ContadorDialogStore } from "../../stores/perfil/ContadorDialogStore";
const InputMask = require("react-input-mask");

interface CreateUserDialogProps {
  onClose: () => void;
  item: IContador;
}

interface CreateUserDialogState {
  conta_id: any;
  list: any[];
}

@observer
export class CreateContadorDialog
  extends React.Component<CreateUserDialogProps, CreateUserDialogState> {

  constructor(props) {
    super(props);
    ContadorDialogStore.obs.contador = newIContador();

    if (this.props.item.nome != "") {
      ContadorDialogStore.obs.is_edit = true;
      ContadorDialogStore.obs.cep_is_valid = true
      ContadorDialogStore.obs.contador = this.props.item;
    }
  }

  async handleCep(vl: string) {
    if (!isNaN(Number(vl.replace("-", ""))) && vl != "") {
      ContadorDialogStore.obs.contador.cep = vl.replace("-", "");

      await ContadorDialogStore.handleGetEnderecoForCEP(
        parseInt(vl.replace("-", "")),
      );

      ContadorDialogStore.obs.contador.endereco = ContadorDialogStore.obs.endereco;
    }
  }

  render() {
    return (
      <>
        <div className={Classes.DIALOG_BODY}>
          <MDBRow>
            <MDBCol style={{ width: "48%", float: "left" }}>
              <FormGroup
                label="Nome Completo"
                labelFor="current-password"
                labelInfo="(obrigatório)"
              >
                <InputGroup
                  defaultValue={this.props.item.nome}
                  onChange={(e: any) => ContadorDialogStore.obs.contador.nome = e.target.value}
                />
              </FormGroup>
            </MDBCol>
            <MDBCol style={{ width: "48%", float: "right" }}>
                <FormGroup
                  label="E-mail"
                  labelFor="current-password"
                  labelInfo="(obrigatório)"
                >
                  <InputGroup
                    name='new-email' autoComplete='new-email'
                    defaultValue={this.props.item.email}
                    onChange={(e: any) => ContadorDialogStore.obs.contador.email = e.target.value}
                  />
                </FormGroup>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <MDBCol style={{ width: "48%", float: "left" }}>
              <FormGroup
                label="CPF"
                labelFor="current-password"
                labelInfo="(obrigatório)"
              >
                <InputMask
                  defaultValue={this.props.item.cpf}
                  className="form-control"
                  mask="999.999.999-99"
                  onChange={(e: any) => ContadorDialogStore.obs.contador.cpf = e.target.value}
                />
              </FormGroup>
            </MDBCol>
            <MDBCol style={{ width: "48%", float: "right" }}>
              <FormGroup
                label="CRC"
                labelFor="current-password"
                labelInfo="(obrigatório)"
              >
                <InputGroup
                  defaultValue={this.props.item.crc}
                  onChange={(e: any) => ContadorDialogStore.obs.contador.crc = e.target.value}
                />
              </FormGroup>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <FormGroup
              style={{ marginLeft: "12px" }}
              label="Rua"
              labelFor="current-password"
            >
              <InputGroup
                disabled={true}
                defaultValue={this.props.item.endereco.logradouro}
                value={ContadorDialogStore.obs.contador.endereco.logradouro}
              />
            </FormGroup>

            <FormGroup
              style={{ marginLeft: "10px" }}
              label="Bairro"
              labelFor="current-password"
            >
              <InputGroup
                disabled={true}
                defaultValue={this.props.item.endereco.bairro}
                value={ContadorDialogStore.obs.contador.endereco.bairro}
              />
            </FormGroup>

            <FormGroup
              style={{ marginLeft: "10px" }}
              label="Cidade"
              labelFor="current-password"
            >
              <InputGroup
                disabled={true}
                defaultValue={this.props.item.endereco.localidade}
                value={ContadorDialogStore.obs.contador.endereco.localidade}
              />
            </FormGroup>

            <FormGroup
              style={{ marginLeft: "10px" }}
              label="CEP"
              labelFor="current-password"
              labelInfo="(obrigatório)"
            >
              <InputMask
                defaultValue={this.props.item.cep}
                className="form-control"
                mask="99999-999"
                onChange={(e: any) => this.handleCep(e.target.value)}
              />
            </FormGroup>

            <FormGroup
              style={{ width: "17.5%", marginLeft: "10px" }}
              label="IBGE"
              labelFor="current-password"
            >
              <InputGroup
                defaultValue={this.props.item.endereco.ibge}
                disabled={true}
                value={ContadorDialogStore.obs.contador.endereco.ibge}
              />
            </FormGroup>
          </MDBRow>
        </div>
      </>
    );
  }
}
